import { countries } from "countries-list";
import getUnicodeFlagIcon from "country-flag-icons/unicode";

// Convert countries object to array and sort by name
export const COUNTRIES = Object.entries(countries)
  .map(([code, country]) => ({
    code,
    name: country.name,
    flag: getUnicodeFlagIcon(code),
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const FUNNEL_OPTIONS = [
  { value: "google", label: "Google Search" },
  { value: "twitter", label: "Twitter/X" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "facebook", label: "Facebook" },
  { value: "instagram", label: "Instagram" },
  { value: "tiktok", label: "TikTok" },
  { value: "youtube", label: "YouTube" },
  { value: "referral", label: "Friend/Colleague Referral" },
  { value: "other", label: "Other" },
] as const;
